import { calciteTypeToChartDataType } from "../chart/hql/chartHqlUtils.js";
import { ChartDataType } from "../chart/types.js";
import { assertNever } from "../errors.js";
import { CalciteType, HqlAggregationFunction } from "../hql/types.js";

import { getFieldActiveScaleType } from "./exploreFieldUtils.js";
import { ExploreField, ExploreVisualizationType } from "./types.js";

export function getExploreSimpleType(
  field: ExploreField,
  vizType: ExploreVisualizationType,
): ChartDataType {
  if (vizType === "pivot-table") {
    return calciteTypeToChartDataType(field.dataType);
  } else if (vizType === "chart") {
    return getFieldActiveScaleType(field);
  } else {
    assertNever(vizType, vizType);
  }
}

export const exploreStringAggregations: HqlAggregationFunction[] = [
  "Count",
  "CountDistinct",
];
export const exploreDatetimeAggregations: HqlAggregationFunction[] = [
  "Count",
  "CountDistinct",
  "Min",
  "Max",
];
export const exploreNumberAggregations: HqlAggregationFunction[] = [
  "Sum",
  "Count",
  "Avg",
  "Min",
  "Max",
  "CountDistinct",
  "Median",
  "StdDev",
  "StdDevPop",
  "Variance",
  "VariancePop",
];

// these aggs return the same type as the input
// every agg not in this list will return a number
// TODO if Median ever works for dates, add it to this list
// TODO if we ever add Mode or MostFrequent or similar, add it to this list
export const exploreSameOutputTypeAggregations: HqlAggregationFunction[] = [
  "Min",
  "Max",
];

// TODO: Deduplicate logic with getExploreSimpleType / getFieldActiveScaleType
/**
 * Returns the actual output type of a field after considering its aggregation.
 * Most aggregations (Count, Sum, Avg, etc.) return numbers regardless of input type.
 * Only Min/Max preserve the original field type.
 *
 * also dedupe with aggregateAlwaysPossible in chartConstants.ts
 */
export function getFieldOutputType(field: ExploreField): CalciteType {
  return field.aggregation == null ||
    exploreSameOutputTypeAggregations.includes(field.aggregation)
    ? field.dataType
    : "DOUBLE";
}
